const initialState = {
	list: [],
	page: 1,
	isList: true,
	isListNext: false,
	datetime: null,
};

export default function reducer(state = initialState, action) {
	if (action.type === 'TIMELINE_LIST_SET') {
		let newState = Object.assign({}, state);

		action.payload.list.forEach((item, index) => {
			action.payload.list[index].more = false;
		});

		newState.list = action.payload.list;
		newState.page = action.payload.page;
		newState.isList = action.payload.isList;
		newState.isListNext = action.payload.isListNext;
		newState.datetime = action.payload.datetime;
		return newState;
	}
	else if (action.type === 'TIMELINE_LIST_INIT') {
		return initialState;
	}
	else if (action.type === 'TIMELINE_ITEM_SET') {
		let newState = Object.assign({}, state);
		if (action.payload.type === 'del') {
			let list = newState.list.filter((value) => (value.userdata_id_code !== action.payload.pic));
			newState.list = list;
		}
		return newState;
	}
	else if (action.type === 'TIMELINE_FOOTPRINT_LIST_SET') {
		let newState = Object.assign({}, state);
		let index = newState.list.findIndex((v) => (v.date === action.payload.date && v.type === "partnerFootprint"));

		if (index >= 0) {
			let footprintList = newState.list[index].list;
			footprintList = [...footprintList, ...action.payload.list];
			newState.list[index].list = footprintList;
			newState.list[index].page = action.payload.page;
			newState.list[index].isListNext = action.payload.isListNext;
		}
		return newState;
	}
	else if (action.type === 'TIMELINE_FOOTPRINT_ITEM_SET') {
		let newState = Object.assign({}, state);
		if (action.payload.type === 'del') {
			newState.list.forEach((item, index) => {
				if(item.type === "partnerFootprint") {
					let list = item.list;
					list = list.filter((value) => (value.userdata_id_code !== action.payload.pic));
					newState.list[index].list = list;
				}
			});
		}

		return newState;
	}

	else if (action.type === 'TIMELINE_POST_GOOD_SET') {
		let newState = Object.assign({}, state);
		let index = newState.list.findIndex((v) => v.id === action.payload.postId);

		if (index >= 0) {
			newState.list[index]['post_good_count'] = action.payload.goodCount;
			newState.list[index]['post_good_sended'] = action.payload.goodSended;
		}
		return newState;
	}
	else if (action.type === 'TIMELINE_QA_QUESTION_ANSWER_SET') {
		let newState = Object.assign({}, state);
		let index = newState.list.findIndex((v) => v.id === action.payload.qaId);

		if (index >= 0) {
			newState.list[index]['qa_answered'] = action.payload.answerText;
		}
		return newState;

	}
	else {
		return state;
	}
}
